import React from "react"

const AIPlanner = () => {
  return (
    <div
      style={{
        borderRadius: "20px",
        border: "1px solid #6C6C6C",
        background: "rgba(0, 0, 0, 0.10)",
        backdropFilter: "blur(12px)",
      }}
      className="text-white"
    >
      AI planner
    </div>
  )
}

export default AIPlanner
